(function () {
    "use strict";

    Controllers.CalendarAbstractController = class CalendarAbstractController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, CalendarService, NavigationService, AppStates, UsersManager, SchedulingService) {
            super($scope, $injector);
            this.__objectType = 'CalendarAbstractController';

            this.CalendarService = CalendarService;
            this.NavigationService = NavigationService;
            this.AppStates = AppStates;
            this.UsersManager = UsersManager;
            this.SchedulingService = SchedulingService;

            this.calendarView = this.CalendarService.CALENDAR_MONTH_VIEW;
            this.hbCalendar = {
                title: ''
            };

            this.user = this.UsersManager.getCurrUser();
            this.isSchedulingEnabled = this.SchedulingService.isSchedulingEnabled(this.user);
            // this.isSchedulingEnabled = true;
            this.isSchedulingPageActive = this.NavigationService.isRouteActive(this.AppStates.root_core_navigation_scheduling);
        }

        setCalendarView(view) {
            this.calendarView = view;
        }

        setCalendarActive() {
            this.isSchedulingPageActive = false;
        }

        setSchedulingActive() {
            this.isSchedulingPageActive = true;
        }

        toggleView () {
            if(this.isSchedulingPageActive) {
                this.$state.go(this.AppStates.root_core_navigation_scheduling, {});
            } else {
                this.$state.go(this.AppStates.root_core_navigation_calendar, {});
            }
        }

        toolbarViewChange (view) {
            if(this._callback) {
                this._callback('changeView', view);
            }
        }

        toolbarTodayChange () {
            if(this._callback) {
                this._callback('today');
            }
        }

        toolbarControlChange (direction) {
            if(this._callback) {
                this._callback('move', direction);
            }
        }

        onCalendarToolbarEvent(callback) {
            this._callback = callback;
        }
    };

}());
